import {
  IXD_CONVERSION_NOTICE,
  IxdConversionGuideButton,
} from "@/components/ixd-upload-notice";
import { Info } from "lucide-react";
import type { ReactNode } from "react";

/** 패널 상단의 회색 안내 줄. STEP 패널들이 함께 쓴다. */
export const Notice = ({
  children,
  details,
}: {
  children: ReactNode;
  /** 안내 줄 아래 들여쓴 불릿 목록 */
  details?: ReactNode[];
}) => (
  <div className="flex w-full flex-col gap-1 rounded-lg bg-neutral-100 px-3 py-2">
    <div className="flex w-full items-center gap-2">
      <img
        alt=""
        src="/icons/info-rounded-alternative.svg"
        className="size-5 shrink-0"
      />
      <p className="caption-1-regular text-label-normal">{children}</p>
    </div>
    {!!details?.length && (
      /* pl 42px = Figma 들여쓰기 24px + disc 마커 18px (아이콘 20px + gap 8px 과도 맞는 값) */
      <ul className="caption-1-regular list-disc pl-[42px] text-label-normal">
        {details.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    )}
  </div>
);

/** 패널 하단의 IXD 파일 안내. IXD 를 받는 STEP 패널들이 함께 쓴다. */
export const IxdFileGuide = () => (
  <div className="flex w-full flex-col gap-2 rounded-lg bg-neutral-100 pt-3 pr-1 pb-4 pl-3">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Info className="size-4 text-label-normal" strokeWidth={1.8} />
        <p className="label-2-semibold text-label-normal">IXD 파일 안내</p>
      </div>
      <IxdConversionGuideButton />
    </div>
    <p className="caption-1-regular text-label-normal">
      {IXD_CONVERSION_NOTICE}
    </p>
  </div>
);
